import Pages from "pages";
import { DynamicThemeProvider } from 'components/common/DynamicThemeProvider';

export default function App() {
  return (
    <DynamicThemeProvider>
      <Pages />
    </DynamicThemeProvider>
  );
}
